define(['text!./templates/promotion-modal.html'], (promotionModalTemplate) => {

    const directive = (ModalService, ViewModelService) => {

        return {
            restrict: 'A',
            scope: {
                bpmPromotionData: '=',
            },
            link: function ($scope, element) {
                element.on(
                    'click',
                    () => ModalService.showSimpleDialog(promotionModalTemplate, { promotions: $scope.bpmPromotionData })
                );

                $scope.bpmPromotionData.forEach((group) => {
                    group.promotions = group.promotions
                        .map((promotion) => {
                            const promotionViewModel = ViewModelService.create(promotion, 'pc', 'ch.baloise.gw.pc.edge.capabilities.quote.lob.mfp.quoting.dto.MFPVehicleCovPremiumFreeCost_ExtDTO');
                            promotion.promotionDescription = promotionViewModel.promotionDescription.value.name;
                            return promotion;
                        });
                });
            },
        };

    };

    directive.$inject = ['ModalService', 'ViewModelService'];
    return directive;
});



// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/baslercommon/directives/BaslerPromotionModal.js